module.exports = __webpack_public_path__ + "static/media/user.26c82cd6.svg";